export function link() {
  const aElementList = document.querySelectorAll('a');
  aElementList.forEach((element) => {
    if (element.hasAttribute('target') === false) {
      return;
    }
    if (element.getAttribute('target') !== '_blank') {
      return;
    }
    element.setAttribute('rel', 'noopener');
    element.classList.add('external');
  });
}
